import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import {Button, Card, CardBody, CardTitle} from "reactstrap";
import {TextField} from '@material-ui/core';
import API from "@beardeddevops/react.api";

const OVERDUE_DAYS_NAME = 'helpdesk_call_overdue_days';
const SNOOZE_MINUTES_NAME = 'helpdesk_call_banner_snooze_minutes';

const breadcrumbStatic = [{
	name: 'Helpdesk Settings',
	url: '/admins/helpdesk_settings',
	icon: 'dashboard'
}];

export default class Helpdesk_Settings extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			saving: false,
			countVariableByName: {},
			overdueDays: '3',
			snoozeMinutes: '30',
		};
	}

	componentDidMount() {
		this.loadCountVariables();
	}

	parseNumber = (value) => {
		const parsed = parseInt(value, 10);
		return Number.isNaN(parsed) ? 0 : parsed;
	}

	handleInputChange = (field) => (e) => {
		const value = e.target.value;
		if (/^\d*$/.test(value)) {
			this.setState({[field]: value});
		}
	}

	loadCountVariables = async () => {
		this.setState({loading: true});

		try {
			const model = new API.BuildClass(Types.Count_Variables._name, API.RequestType.READ);
			model.filter = {
				names: [OVERDUE_DAYS_NAME, SNOOZE_MINUTES_NAME]
			};
			const response = await model.submit(null, "GET_ALL");
			const byName = response?.by_name || {};

			this.setState({
				countVariableByName: byName,
				overdueDays: String(byName[OVERDUE_DAYS_NAME]?.amount ?? 3),
				snoozeMinutes: String(byName[SNOOZE_MINUTES_NAME]?.amount ?? 30),
			});
		} catch (error) {
			console.error('Failed to load helpdesk settings', error);
			API.Toast.error('Failed to load helpdesk settings.');
		} finally {
			this.setState({loading: false});
		}
	}

	upsertCountVariable = async (name, amount) => {
		const existing = this.state.countVariableByName[name];
		const numericAmount = this.parseNumber(amount);
		if (existing && existing.amount === numericAmount) {
			return true;
		}
		const requestType = existing?.pkey ? API.RequestType.UPDATE : API.RequestType.CREATE;
		const model = new API.BuildClass(Types.Count_Variables._name, requestType);

		if (existing?.pkey) {
			model.object.pkey = existing.pkey;
		}
		model.object.name = name;
		model.object.amount = numericAmount;

		await model.submit(null, existing?.pkey ? 'POST' : 'PUT');

		return true;
	}

	handleSave = async () => {
		this.setState({saving: true});
		try {
			await this.upsertCountVariable(OVERDUE_DAYS_NAME, this.state.overdueDays);
			await this.upsertCountVariable(SNOOZE_MINUTES_NAME, this.state.snoozeMinutes);
			API.Toast.success('Helpdesk settings saved.');
			await this.loadCountVariables();
		} catch (error) {
			console.error('Failed to save helpdesk settings', error);
			API.Toast.error('Failed to save helpdesk settings.');
		} finally {
			this.setState({saving: false});
		}
	}

	render() {
		const {loading, saving, overdueDays, snoozeMinutes} = this.state;

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={this.props.history}>
					<Button
						size="sm"
						color="primary"
						disabled={loading || saving}
						onClick={this.handleSave}
					>
						{saving ? 'Saving...' : 'Save Settings'}
					</Button>
				</Framework.Components.PageBar>

				<Card>
					<CardBody>
						<CardTitle tag="h5">FE Call Reminder Settings</CardTitle>
						<p className="text-muted mb-4">
							Configure how long a field engineer can go without a helpdesk call before reminders are created, and how long a dismissed banner stays hidden.
						</p>
						<div className="row">
							<div className="col-md-6 mb-3">
								<TextField
									margin="dense"
									label="Days before call is overdue"
									type="text"
									fullWidth
									disabled={loading || saving}
									value={overdueDays}
									onChange={this.handleInputChange('overdueDays')}
									variant="outlined"
									helperText="Active FEs with no contact for this many days generate helpdesk notifications."
									inputProps={{pattern: '[0-9]*'}}
								/>
							</div>
							<div className="col-md-6 mb-3">
								<TextField
									margin="dense"
									label="Banner snooze (minutes)"
									type="text"
									fullWidth
									disabled={loading || saving}
									value={snoozeMinutes}
									onChange={this.handleInputChange('snoozeMinutes')}
									variant="outlined"
									helperText="After dismiss, the same call banner reappears after this many minutes."
									inputProps={{pattern: '[0-9]*'}}
								/>
							</div>
						</div>
					</CardBody>
				</Card>
			</div>
		);
	}
}
